import styled from 'styled-components';

export const StyledDragWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 258px;
  border-radius: 6px;
  border: 1.5px dashed #e6e6e6;
  background: #fff;

  span {
    color: var(--color-primary-blue);
  }
`;

export const StyledDownloadWrapper = styled.div`
  padding: 20px 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-radius: 6px;
  border: 1px solid #e6e6e6;
  background: #fff;
`;
